function switchTab() {
    const tabs = document.querySelectorAll(".tab-header__item"),
      tabsContent = document.querySelectorAll(".tab-content__text"),
      tabsParent = document.querySelector(".tab-header__items");

    function observeQuestElement() {
      const observer = new MutationObserver(() => {
        const question = document.querySelector('.tab-content__text--question #judgeme_product_reviews [data-tabname="questions"]');
        if (question && !question.classList.contains('test')) {
          question.click();
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    observeQuestElement();

    function hideTabContent() {
      if (tabsContent.length) {
        tabsContent?.forEach((el) => {
          el.classList.add("hide");
          el.classList.remove("show", "fade");
        });
      }

      if (tabs.length) {
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
      }
    }

    function showTabContent(i = 0) {
      tabsContent[i]?.classList.add("show", "fade");
      tabsContent[i]?.classList.remove("hide");
      tabs[i].classList.add("active");
    }

    hideTabContent();
    showTabContent();

    tabsParent.addEventListener("click", (e) => {
      const target = e.target;

      if (target && target.classList.contains("tab-header__item")) {
        tabs.forEach((item, i) => {
          if (target === item) {
            hideTabContent();
            showTabContent(i);
          }
        });
      }
    });
  }

  switchTab();

  function tabsDropDown() {
    const tabParentMob = document.querySelector(".tab-header__items--mob");

    tabParentMob?.addEventListener("click", () => {
      tabParentMob.classList.toggle("open");
    })
  }

  tabsDropDown();

// Function to update tab titles and set click listeners
function tabTitleCount() {
  const reviewsSelector = ".jdgm-prev-badge__text";
  const questionSelector = ".jdgm-qa-badge__text";
  const questionTabSelector = "[data-app-title-question]";
  const reviewsTabSelector = "[data-app-title-reviews]";
  const tabParentMobSelector = ".tab-header__items--mob";

  const reviewsTab = document.querySelector(reviewsTabSelector);
  const questionTab = document.querySelector(questionTabSelector);
  const tabParentMob = document.querySelector(tabParentMobSelector);

  if (!reviewsTab || !questionTab || !tabParentMob) {
    return;
  }

  // Utility to extract numeric content from text
  const extractNumber = (text) => text.replace(/[^0-9]/g, "");

  // Update reviews tab title with count
  const updateReviewsTab = () => {
    const reviewsCount = document.querySelector(reviewsSelector)?.textContent;
    if (reviewsCount) {
      const extractedCount = extractNumber(reviewsCount);
      if (extractedCount) {
        reviewsTab.textContent += ` (${extractedCount})`;
      }
    }
  };

  // Update question tab title with count once available
  const updateQuestionTab = () => {
    const observer = new MutationObserver(() => {
      const questionCountElement = document.querySelector(questionSelector);

      if (questionCountElement) {
        const questionCount = extractNumber(questionCountElement.textContent);
        if (questionCount) {
          questionTab.textContent += ` (${questionCount})`;
        }

        attachEventListeners();
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  // Attach click event listeners for badges
  const attachEventListeners = () => {
    const questionBadge = document.querySelector(".jdgm-qa-badge");
    const starsBadge = document.querySelector(".jdgm-prev-badge__stars");
    const reviewsBadge = document.querySelector(".jdgm-prev-badge__text");

    if (questionBadge) {
      questionBadge.addEventListener("click", () => {
        questionTab.click();
        tabParentMob.classList.remove("open");
      });
    }

    if (starsBadge) {
      starsBadge.addEventListener("click", () => {
        reviewsTab.click();
        tabParentMob.classList.remove("open");
      });
    }

    if (reviewsBadge) {
      reviewsBadge.addEventListener("click", () => {
        reviewsTab.click();
        tabParentMob.classList.remove("open");
      });
    }
  };

  updateReviewsTab();
  updateQuestionTab();
}

document.addEventListener("DOMContentLoaded", tabTitleCount);
